

import { React, useState } from 'react';
import "./landingpage.css"
import Logo from "../assets/images/pro360.png"
import QLogo from "../assets/images/Qfinitylogos.png"
import BlueLogo from '../assets/images/blueCoco.png';
import YourLogo from "../../INVENTORY/Assets/images/yourlogo.png";

const Footer = () => {

    return (
        <div class="container">
            <footer class="py-5">
                <div class="row">
                    <div class="col-4">
                        <div>
                            {/* <img src={BlueLogo} /> */}
                            {/* <img src={Logo} /> */}
                            <img src={YourLogo} style={{ height: "40px" }} />
                            {/* <img src={QLogo} /> */}
                        </div>
                        <div className='py-3'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore .Learn more
                        </div>
                        <div className='openhor'>OPENING HOURS</div>
                        <div className='d-flex justify-content-between py-3'>
                            <div className='opntime'>
                                <div>Monday - Friday</div>
                                <div>8:00 am to 9:00 pm</div>
                            </div>
                            <div className='opntime'>
                                <div>Saturday</div>
                                <div>8:00 am to 9:00 pm</div>
                            </div>
                            <div className='opntime'>
                                <div>Sunday</div>
                                <div>CLOSED</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-4">
                        <div className=''>
                            <ul class="nav flex-column">
                                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Home</a></li>
                                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Features</a></li>
                                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Pricing</a></li>
                                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">FAQs</a></li>
                                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">About</a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-4">
                        <form>
                            <h5>Subscribe to our newsletter</h5>
                            <p>Monthly digest of whats new and exciting from us.</p>
                            <div class="d-flex w-100 gap-2">
                                <label for="newsletter1" class="visually-hidden">Email address</label>
                                <input id="newsletter1" type="text" class="form-control" placeholder="Email address" />
                                <button class="btn btn-primary" type="button">Subscribe</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="d-flex justify-content-between py-4 my-4 border-top">
                    <p>© 2024 Restaurants. All Right Reserved</p>
                    <ul class="list-unstyled d-flex">
                        <li class="ms-3"><a class="link-dark" href="#"><svg class="bi" width="24" height="24"></svg></a></li>
                        <li class="ms-3"><a class="link-dark" href="#"><svg class="bi" width="24" height="24"></svg></a></li>
                        <li class="ms-3"><a class="link-dark" href="#"><svg class="bi" width="24" height="24"></svg></a></li>
                    </ul>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
